import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#1F2125",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M9.402 2.878c.192-.39.288-.584.419-.646a.42.42 0 0 1 .358 0c.13.062.227.257.419.646l1.822 3.691a1 1 0 0 0 .127.217q.054.06.13.095c.054.025.118.034.244.053l4.076.596c.43.062.644.094.744.199a.42.42 0 0 1 .11.34c-.019.144-.174.295-.485.598l-2.948 2.872c-.092.09-.138.134-.168.187a.4.4 0 0 0-.05.153c-.007.06.004.123.026.25l.696 4.056c.073.428.11.642.04.769a.42.42 0 0 1-.29.21c-.142.027-.334-.074-.718-.276L10.31 14.97c-.113-.06-.17-.09-.23-.1a.4.4 0 0 0-.16 0c-.06.01-.117.04-.23.1l-3.644 1.917c-.384.202-.577.303-.719.276a.42.42 0 0 1-.29-.21c-.069-.127-.032-.341.041-.769l.696-4.056a1 1 0 0 0 .025-.25.4.4 0 0 0-.05-.153c-.029-.053-.075-.098-.167-.187L2.634 8.667c-.311-.303-.466-.454-.485-.597a.42.42 0 0 1 .11-.341c.1-.105.314-.137.744-.2l4.076-.595c.126-.019.19-.028.245-.054a.4.4 0 0 0 .13-.094c.04-.044.07-.102.126-.217z"
    }, null, -1)
  ]))]))
}
export default { render: render }